module.exports = __webpack_public_path__ + "static/media/banjo_and_kazooie.24a02ea1.png";